<template>
  <section class="sear-wrap">
    <!-- 行业成本数据 -->
    <IndustryCostData></IndustryCostData>
    <!-- 业务毛利查询（暂时隐藏） -->
    <!-- <BusinessQuery2></BusinessQuery2> -->
    <!-- <Q4LocalChainCustomer></Q4LocalChainCustomer> -->
    <!-- 2年未收服务费客户查询 -->
    <WeiShouFuWuFei></WeiShouFuWuFei>
    <!-- 百度推广客服查询 -->
    <BaiDucompanySearch></BaiDucompanySearch>
    <!-- 惠生活账户到期时间查询 -->
    <HSHExpirationTimeQuery></HSHExpirationTimeQuery>
    <!-- 爱采购客服及到期时间查询 -->
    <ACGExpirationTimeQuery></ACGExpirationTimeQuery>
    <!-- 爱采购行业案例查询 -->
    <IndustryCaseQuery></IndustryCaseQuery>
  </section>
</template>
<script>
import BaiDucompanySearch from "../components/BaiDucompanySearch.vue";
import ACGExpirationTimeQuery from "../components/ACGExpirationTimeQuery.vue";
import IndustryCaseQuery from "../components/IndustryCaseQuery.vue";
import IndustryCostData from "../components/IndustryCostData.vue";
import HSHExpirationTimeQuery from "../components/HSHExpirationTimeQuery.vue";
// import MTkebaoQuery from "../components/MTkebaoQuery.vue";
// import BusinessQuery2 from "../components/BusinessQuery2.vue";
import WeiShouFuWuFei from "../components/WeiShouFuWuFei.vue";
// import BusinessQuery from "../components/BusinessQuery.vue";
// import Q4LocalChainCustomer from "../components/Q4LocalChainCustomer.vue";
export default {
  components: {
    BaiDucompanySearch,
    ACGExpirationTimeQuery,
    IndustryCaseQuery,
    IndustryCostData,
    HSHExpirationTimeQuery,
    // MTkebaoQuery,
    // BusinessQuery2, // 业务毛利查询（暂时隐藏）
    WeiShouFuWuFei,
    // BusinessQuery, // 业务毛利查询
    // Q4LocalChainCustomer
  },
  data() {
    return {};
  },

  methods: {},
};
</script>
<style scoped lang="less">
@import "../assets/reset.less";
body {
  background-color: #fff;
}

.sear-wrap {
  margin: 0px auto;
  padding: 5px;
  margin-left: 10px;
  margin-right: 10px;
}


</style>